import { useState, useEffect } from 'react';
import { getApiCallCounts, resetApiCallTracking } from '@/utils/debug-utils';

export function DevTools() {
  const [apiCalls, setApiCalls] = useState<Record<string, number>>({});
  const [expanded, setExpanded] = useState(false);

  // Update API call counts every second
  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') return;

    const interval = setInterval(() => {
      setApiCalls(getApiCallCounts());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  if (process.env.NODE_ENV !== 'development') return null;

  return (
    <div 
      style={{
        position: 'fixed',
        bottom: 10,
        right: 10,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        color: 'white',
        padding: expanded ? '10px' : '5px',
        borderRadius: '5px',
        fontSize: '12px',
        zIndex: 9999,
        maxWidth: expanded ? '400px' : '50px',
        maxHeight: expanded ? '400px' : '30px',
        overflow: 'auto'
      }}
    >
      {expanded ? (
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
            <h3 style={{ margin: 0 }}>API Call Tracker</h3>
            <div>
              <button 
                onClick={() => resetApiCallTracking()}
                style={{ marginRight: '10px', backgroundColor: 'transparent', color: 'white', border: '1px solid white', padding: '2px 5px' }}
              >
                Reset
              </button>
              <button 
                onClick={() => setExpanded(false)}
                style={{ backgroundColor: 'transparent', color: 'white', border: '1px solid white', padding: '2px 5px' }}
              >
                Minimize
              </button>
            </div>
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={{ textAlign: 'left', padding: '5px' }}>Endpoint</th>
                <th style={{ textAlign: 'center', padding: '5px' }}>Count</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(apiCalls).map(([endpoint, count]) => (
                <tr key={endpoint} style={{ borderBottom: '1px solid rgba(255, 255, 255, 0.2)' }}>
                  <td style={{ padding: '5px' }}>{endpoint}</td>
                  <td style={{ textAlign: 'center', padding: '5px' }}>{count}</td>
                </tr>
              ))}
              {Object.keys(apiCalls).length === 0 && (
                <tr>
                  <td colSpan={2} style={{ textAlign: 'center', padding: '10px' }}>No API calls tracked yet</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      ) : (
        <div style={{ cursor: 'pointer' }} onClick={() => setExpanded(true)}>
          🔄 {Object.values(apiCalls).reduce((sum, count) => sum + count, 0)}
        </div>
      )}
    </div>
  );
} 